module.exports = {
      id: "empty-list-usage",
      viewBox: "0 0 1500 1500",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#empty-list-usage",
      toString: function () {
        return this.url;
      }
    }